import { render, staticRenderFns } from "./SubcategoryList.vue?vue&type=template&id=0207ffd5&"
import script from "./SubcategoryList.vue?vue&type=script&lang=js&"
export * from "./SubcategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports